import React from 'react';
import { Outlet } from 'react-router-dom';

const RELOAD_ON_ERROR = true;
const RELOAD_ON_ERROR_DELAY = 1000;

class ObsLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {

      window.onerror = (message, source, lineno, colno, error) => {
        this.setState({ hasError: true });

        if (RELOAD_ON_ERROR) {
          console.log('Reloading page due to error...');
          setTimeout(() => window.location.reload(), RELOAD_ON_ERROR_DELAY)
        }

        return true; // Prevent default error handling
      };
    }
  }

  componentWillUnmount() {
    // Restore window.onerror
    window.onerror = null;
  }

  componentDidCatch(error, errorInfo) {
    console.log('OBS Error caught:', error);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="realtive w-screen h-screen flex items-center justify-center bg-transparent text-white overflow-hidden">
            <div className="absolute bottom-0 right-0 px-10 py-5 flex items-center justify-center text-3xl overflow-hidden">⚠️</div>
        </div>
      );
    }

    return <Outlet />;
  }
}

export default ObsLayout; 